import { render, staticRenderFns } from "./materiais.vue?vue&type=template&id=0e0ce9f0&"
import script from "./materiais.vue?vue&type=script&lang=js&"
export * from "./materiais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports